/**
 * Models
 */
export const DietAllergen = (json: IDietAllergen): IDietAllergenModel => {
	const { name, is_active, created_at, updated_at, ...rest } = json

	return {
		isActive: is_active,
		name: LangContentToModel(name),
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		...rest,
	}
}

/**
 * Payloads
 */
export const DietAllergenUpdateToPayload = (
	allergen: IDietAllergenModel,
	updated: IDietAllergenUpdate,
): Partial<IDietAllergen> => {
	const { name, isActive, ...rest } = allergen

	return {
		...rest,
		code: updated.code,
		is_active: isActive,
		name: LangContentToJson(name, updated.name),
	}
}

export const DietAllergenCreateToPayload = (data: IDietAllergenUpdate, isActive = true): Partial<IDietAllergen> => {
	const { name, ...rest } = data

	return {
		...rest,
		is_active: isActive,
		name: generateLangContentArray(name),
	}
}
